import React from "react";
import { useDemo } from "@client.hooks/useDemo";
import "./DemoBadge.scss";

const DemoBadge = () => {
  const { isDemo } = useDemo();

  if (!isDemo) return null;

  return (
    <div className="demo-badge">
      <span className="demo-badge-text">Demo Mode</span>
    </div>
  );
};

export default DemoBadge;
